// LA COULEUR D'UN FILM DE SAVON, pour Bubbles : l'interférence à deux ondes
// entre les deux faces d'un film d'eau savonneuse (n = 1,33), intégrée contre
// les fonctions colorimétriques CIE 1931 (ajustement de Wyman, Sloan et Shirley
// 2013), balance des blancs sur un spectre plat. La même loi que bubble.js
// (reprise ici sans dépendance au navigateur, pour le test Node). Le shader lit
// la table à l'ÉPAISSEUR OPTIQUE h·cos θt : la couleur glisse avec l'angle de vue.

export const N_FILM = 1.33;
export const FILM_H_MAX = 900;          // nm : la table couvre 0..900 nm
export const FILM_LUT = 512;
const LAMBDAS = [400, 427, 455, 482, 509, 536, 564, 591, 618, 645, 673, 700];
function lobe(l, mu, s1, s2) { const s = l < mu ? s1 : s2; const t = (l - mu) / s; return Math.exp(-0.5 * t * t); }
function cieXYZ(l) {
  return [
    1.056 * lobe(l, 599.8, 37.9, 31.0) + 0.362 * lobe(l, 442.0, 16.0, 26.7) - 0.065 * lobe(l, 501.1, 20.4, 26.2),
    0.821 * lobe(l, 568.8, 46.9, 40.5) + 0.286 * lobe(l, 530.9, 16.3, 31.1),
    1.217 * lobe(l, 437.0, 11.8, 36.0) + 0.681 * lobe(l, 459.0, 26.0, 13.8)
  ];
}
function xyzToRgb(X, Y, Z) { return [3.2406 * X - 1.5372 * Y - 0.4986 * Z, -0.9689 * X + 1.8758 * Y + 0.0415 * Z, 0.0557 * X - 0.2040 * Y + 1.0570 * Z]; }
const WHITE = (() => { let X = 0, Y = 0, Z = 0; for (const l of LAMBDAS) { const c = cieXYZ(l); X += c[0]; Y += c[1]; Z += c[2]; } return xyzToRgb(X, Y, Z); })();
// le RGB linéaire réfléchi par un film d'épaisseur optique h (nm), relatif à un réflecteur parfait
export function filmColor(h) {
  let X = 0, Y = 0, Z = 0;
  for (const l of LAMBDAS) { const s = Math.sin(2 * Math.PI * N_FILM * h / l); const R = s * s; const c = cieXYZ(l); X += R * c[0]; Y += R * c[1]; Z += R * c[2]; }
  return xyzToRgb(X, Y, Z).map((v, k) => Math.max(0, v / WHITE[k]));
}
// l'épaisseur optique vue sous l'angle d'incidence de cosinus cosI (réfraction dans le film)
export function effectiveThickness(h, cosI) { const s2 = (1 - cosI * cosI) / (N_FILM * N_FILM); return h * Math.sqrt(Math.max(0, 1 - s2)); }
// la table RGBA8 (réflectance relative, bornée à 1 : le shader la module par le Fresnel et l'environnement)
export function filmLutData() {
  const d = new Uint8Array(FILM_LUT * 4);
  for (let i = 0; i < FILM_LUT; i++) {
    const c = filmColor(i / (FILM_LUT - 1) * FILM_H_MAX);
    for (let k = 0; k < 3; k++) d[i * 4 + k] = Math.round(255 * Math.min(1, c[k] * 1.0));
    d[i * 4 + 3] = 255;
  }
  return d;
}
